import React from "react";
import SpendComponent from "../../components/money/spend";

const MoneySpend = () => {
    return (
        <div className="text-black flex-1">
            <SpendComponent />
        </div>
    );
};

export default MoneySpend;
